<!-- Shell chrome, not a nav-items.ts entry: links to the notifications feed with an unread badge. -->
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useUnreadCount } from '../composables/use-unread-count.ts'

const { t } = useI18n()
const { count, atCap } = useUnreadCount()
</script>

<template>
  <RouterLink
    :to="{ name: 'notifications' }"
    :aria-label="count > 0 ? t('notifications.badgeLabel', { count }) : t('notifications.title')"
    class="relative flex h-[var(--density-control)] w-[var(--density-control)] items-center justify-center rounded-[var(--radius-control)] text-[color:var(--color-text-muted)] transition-colors duration-[var(--motion-fast)] hover:bg-[color:var(--color-surface-sunken)] hover:text-[color:var(--color-text)]"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
      stroke-linecap="butt"
      stroke-linejoin="miter"
    >
      <path d="M4 6.6c0-2.5 1.8-4.2 4-4.2s4 1.7 4 4.2v2.6l1.2 2.4H2.8L4 9.2z" />
      <path d="M6.4 12.6c.3.9 1 1.4 1.6 1.4s1.3-.5 1.6-1.4" />
    </svg>
    <span
      v-if="count > 0"
      class="absolute right-0 top-0 flex h-4 min-w-4 items-center justify-center rounded-full bg-[color:var(--color-action)] px-[3px] text-[length:var(--text-step-1)] font-semibold leading-none text-[color:var(--color-action-text)]"
    >
      {{ atCap ? `${count}+` : count }}
    </span>
  </RouterLink>
</template>
